import { Injectable } from '@angular/core';

import { UtilsService } from './utils.service';
import { RouteLegsService } from './routeLegs.service';
import type { TLocation, TRouteLeg, TTicket } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class NavigationHelperService {
    // private routeLegs: TRouteLeg[] = [];

    constructor(private RouteLegsService: RouteLegsService, private utilsService: UtilsService) {
    }

    // Insert the incoming ticket into the tickets array such that it minimizes the travel
    // and backtracking distances. Do this while taking into consideration the number of seats
    // available in the shuttle.
    public async insertTicketIntoRoute(vm: any, ticketToInsert: TTicket) {
        const tempTickets = [];
        // const  condocoordinate = { 'latitude': 34.420514, 'longitude': -118.488589 };
        // const  homeDepotcoordinate = { 'latitude': 34.419174, 'longitude': -118.497052 };
        // const  goldenStarbuckscoordinate = { 'latitude': 34.419152, 'longitude': -118.502860 };
        // const  mountasiacoordinate = { 'latitude': 34.415452, 'longitude': -118.511612 };
        // const  mcDonaldscoordinate = { 'latitude': 34.422378, 'longitude': -118.541789 };
        // const  frontiercoordinate = { 'latitude': 34.418922, 'longitude': -118.554037 };
        // const  valenciaLibrarycoordinate = { 'latitude': 34.415577, 'longitude': -118.550768 };
        // const  cornerBakerycoordinate = { 'latitude': 34.412861, 'longitude': -118.559267 };

        // Condo                  = 20212 Fanchon Lane, Canyon Country, Ca. 91351           (34.420514, -118.488589)
        // Home Depot             = 20642 Golden Triangle Road, Santa Clarita, Ca. 91351    (34.419174, -118.497052)  = 0.49 miles
        // Golden Starbucks       = 26585 Golden Valley Road, Santa Clarita, Ca. 91350      (34.419152, -118.502860)  = 0.33 miles
        // Mountasia              = 21516 Golden Triangle Rd, Santa Clarita, CA 91350       (34.415452, -118.511612)  = 0.56 miles
        // McDonalds              = 23110 Valencia Blvd, Valencia, CA 91355                 (34.422378, -118.541789)  = 1.79 miles
        // Frontier               = 23621 Creekside Rd.  Valencia Ca. 91355                 (34.418922, -118.554037)  = 0.74 miles
        // Valencia Library       = 23743 Valencia Blvd. Santa Clarita Ca. 91355            (34.415577, -118.550768)  = 0.30 miles
        // Corner Bakery          = 24290 Valencia Blvd, Valencia, CA 91355                 (34.412861, -118.559267)  = 0.52 miles
        // UHaul                  = 18716 Soledad Canyon Rd, Santa Clarita, CA 91351
        // Darcy Library          = 18601 Soledad Canyon Rd, Santa Clarita, CA 91351
        // Via Pricessa Starbucks = 26925 Sierra Hwy, Newhall, CA 91321

        let obj;
        const loc = vm.myVector.currentLocation || null;
        obj = { 'locationName': 'here', 'idx': 0, 'coordinate': loc, 'uid': 'here' };
        tempTickets.push(obj);

        // 2) Compute where along the route we have enough seats to accomodate this ticket.
        //    At the point the shuttle has enough seats for the ticket, add the to coordinate to the list.
        let numSeatsAvailable = vm.route.shuttle.passengerCapacity;
        for (let idx = 0; idx < vm.tickets.length; idx++) {
            const ticket = vm.tickets[idx];
            if (ticket.status !== 'completed') {
                numSeatsAvailable -= ticket.numPassengers;
            }
            if (numSeatsAvailable >= ticket.numPassengers) {
                obj = {
                    'locationName': ticket.locationName, 'idx': idx + 1,
                    'coordinate': ticket.tocoordinate, 'uid': ticket.uid
                };
                tempTickets.push(obj);
            }
        }

        // 3) Compute distances from each entry in the list to pickup point.
        const closestTickets = [];
        tempTickets.forEach((ticket) => {
            const distance = this.utilsService.calculateDistance(ticket.coordinate, ticket.fromcoordinate);
            const cw = ticket;
            cw.distance = distance;
            closestTickets.push(cw);
        });

        // 4) Sort this list ascending.
        closestTickets.sort((ticket1, ticket2) => (ticket1.distance.miles - ticket2.distance.miles));

        // 5) The first item in the list is the closest to the incoming tickets pickup location.
        const targetTicket = closestTickets[0];

        // 6) Now determine if this ticket pickup point should be inserted before or after the targetTicket.
        //    Look at the tickets on either side of the targetTicket.  Assume the points on either side of
        //    targetTicket are called prev and next.

        // Get the ticket just before the targetTicket.
        const prevIdx = targetTicket.idx - 1;
        const prevTicket = (prevIdx >= 0 && prevIdx < vm.tickets.length) ?
            vm.tickets[prevIdx] : null;

        // Get the ticket just after the targetTicket.
        const nextIdx = targetTicket.idx + 1;
        const nextTicket = (nextIdx >= 0 && nextIdx < vm.tickets.length - 1) ?
            vm.tickets[nextIdx] : null;

        // 7) Compute the distance from the prevTicket to the pickup location.
        const tocoordinate = ticketToInsert.pickup.address.coordinate;
        let distanceFromPrevToPickup = Number.MAX_SAFE_INTEGER;
        if (prevTicket) {
            obj = this.utilsService.calculateDistance(prevTicket.tocoordinate, tocoordinate);
            distanceFromPrevToPickup = obj.miles;
        }

        // 8) Compute the distance from the nextTicket to the pickup location.
        let distanceFromNextToPickup = Number.MAX_SAFE_INTEGER;
        if (nextTicket) {
            obj = this.utilsService.calculateDistance(nextTicket.tocoordinate, tocoordinate);
            distanceFromNextToPickup = obj.miles;
        }

        // 1) If the prevTicket doesn't exist then insert it after prevTicket
        // 2) If the nextTicket doesn't exist then insert it before nextTicket
        // 3) If they both exist then
        let insertTicketPos;
        if (!prevTicket) {
            insertTicketPos = 0;
        } else if (!nextTicket) {
            insertTicketPos = targetTicket.idx;
        } else {
            // 9) if distance(A-P) > distance(C-P) then insert after B.
            //    if distance(A-P) < distance(C-P) then insert before B.
            insertTicketPos = (distanceFromPrevToPickup < distanceFromNextToPickup) ? targetTicket.idx : targetTicket.idx + 1;
        }

        // If we are going to insert a new ticket at position 0 then the current
        // ticket needs to be reset back to enroute status.
        const doesCurrentTicketExist = vm.tickets.find((ticket) => (ticket.status === 'current'));

        // There is only one scenario in which it makes sense to insert this ticket
        // as the 'current' ticket.  If there is already a current ticket and we need
        // to insert this ticket before the current ticket.
        // Under all other scenarios, make this ticket status enroute.
        ticketToInsert.status = 'enroute';
        if (doesCurrentTicketExist && insertTicketPos === 0) {
            vm.tickets[vm.currentLegIdx].status = 'enroute';
            ticketToInsert.status = 'current';
            vm.currentTicket = ticketToInsert;
        }

        //
        vm.tickets.splice(insertTicketPos, 0, ticketToInsert);

        // console.log('In navigationHelper before buildRouteLegs; vm.route.routeLegs = ', vm.route.routeLegs);
        // Reset the starting point to where we are.
        vm.route.routeLegs = this.RouteLegsService.buildRouteLegs(vm.route.startingPoint, vm.route.endingPoint, vm.tickets);
        // console.log('In navigationHelper after buildRouteLegs; vm.route.routeLegs = ', vm.route.routeLegs);

        // If insertTicketPos === 0, then call nav4.setLegToCurrent
        return insertTicketPos;
    }
}
